// API Configuration from environment variables
export const API_CONFIG = {
  HOST: process.env.REACT_APP_HOST || 'http://localhost',
  BACKEND_PORT: process.env.REACT_APP_BACKEND_PORT || '5000',
  JWT_EXPIRATION_TIME: process.env.REACT_APP_JWT_EXPIRATION_TIME || '24h',
};

// Construct full API base URL
// In production (via Caddy), use just the host with /api prefix (Caddy routes /api/* to backend)
// In development, use host:port directly
const isProduction = process.env.NODE_ENV === 'production' || API_CONFIG.HOST.includes('https://');
export const API_BASE_URL = isProduction 
  ? `${API_CONFIG.HOST}/api`  // Production: https://ums.unibyte.gr/api (Caddy routes to backend:5000)
  : `${API_CONFIG.HOST}:${API_CONFIG.BACKEND_PORT}`;  // Development: http://localhost:5000

/* Socket.IO disabled in frontend for now; uncomment when re-enabling.
export const SOCKET_IO_URL = isProduction
  ? API_CONFIG.HOST
  : `${API_CONFIG.HOST}:${API_CONFIG.BACKEND_PORT}`;
export const SOCKET_IO_PATH = isProduction ? '/api/socket.io' : '/socket.io';
export const SOCKET_IO_TRANSPORTS = isProduction ? ['polling'] : ['websocket', 'polling'];
*/

